import { IInitialState } from 'store/models';
import { moduleStateSelector } from './moduleStateSelector';

export function finishSurveySelector(state: IInitialState) {
	return moduleStateSelector(state).isSurveyFinished;
}

export function redirectDataSelector(state: IInitialState) {
	return moduleStateSelector(state).redirect;
}
